<div class='container'>
    <app-number-field [(model)]="min" (modelChange)="minChange.emit(min)" [max]="max" placeholderText="" [sufix]="percentage?'%':''"></app-number-field>
    <div class='slider'></div>
    <app-number-field [(model)]="max" (modelChange)="maxChange.emit(max)" [min]="min" placeholderText="" [sufix]="percentage?'%':''"></app-number-field>
</div>